/**
 * @fileoverview Link Content View - controls the UI for a link in the social post
 *
 * @author Samantha Landen (slanden@yext.com)
 */
goog.module('yext.social.post.LinkContentView');
goog.module.declareLegacyNamespace();

const yext = goog.require('yext');
const Model = goog.require('yext.mvc.Model');

/** @constructor */
const LinkContentView = function(options) {
  this.options = options || {};

  /** @type {!jQuery} */
  this.$el = this.options.$el || $('.js-post-link-container');

  /**
   * @type {Model}
   * @private
   */
  this.model_ = new Model().init({
    isLoading: this.options.link != null,
    url: this.options.link || null,
    title: null,
    subtitle: null,
    summary: null,
    videoThumbnail: null,
  });

  /**
   * @type {Function}
   * @private
   */
  this.onChange_ = null;
};

/** @return this */
LinkContentView.prototype.init = function() {
  this.bindRemoveLink_();
  this.bindModelChange_();
  this.render_();
  return this;
};

/** @param {Function} cb */
LinkContentView.prototype.onChange = function(cb) {
  if (!yext.isFunction(cb)) {
    throw new TypeError('LinkContentView.onChange: Invalid cb, expected a function');
  }
  this.onChange_ = cb;
};

/** @return {!Object<string, ?>} */
LinkContentView.prototype.getData = function() {
  return {
    'hyperlink': {
      'link': this.model_.get('url'),
      'linkTitle': this.model_.get('title'),
      'linkSubtitle': this.model_.get('subtitle'),
      'linkSummary': this.model_.get('summary'),
    },
  };
};

/** Sets the contents of the link to an empty state */
LinkContentView.prototype.reset = function() {
  this.model_.resetState({
    isLoading: false,
    url: null,
    title: null,
    subtitle: null,
    summary: null,
    videoThumbnail: null,
  });
};

/**
 * Sets the url for the link and indicates that the link is loading
 * @param {string} url
 */
LinkContentView.prototype.setInitialLink = function(url) {
  this.model_.set({
    url: url,
    isLoading: true,
  });
};

/**
 * Sets the link metadata and indicates that the link is done loading
 * @param {string} title
 * @param {string} subtitle
 * @param {string} summary
 * @param {string} videoThumbnail
 */
LinkContentView.prototype.fillInLinkMetadata = function(
  title,
  subtitle,
  summary,
  videoThumbnail) {
  this.model_.set({
    isLoading: false,
    title: title || null,
    subtitle: subtitle || null,
    summary: summary || null,
    videoThumbnail: videoThumbnail || null,
  });
};

/** @private */
LinkContentView.prototype.bindRemoveLink_ = function() {
  this.$el.find('.js-remove-link').on('click', function() {
    this.reset();
  }.bind(this));
};

/** @private */
LinkContentView.prototype.bindModelChange_ = function() {
  this.model_.on('change,reset', function() {
    this.render_();
    if (this.onChange_) {
      this.onChange_(this.getData());
    }
  }.bind(this));
};

/** @private */
LinkContentView.prototype.render_ = function() {
  var isLoading = this.model_.get('isLoading');
  var url = this.model_.get('url') || '';

  this.$el.find('.js-loading').toggle(isLoading);
  if (isLoading) {
    this.$el.find('.js-post-link-title').text(yext.msg('Loading...'));
    this.$el.find('.js-post-link-subtitle').text(url || '');
  } else {
    this.$el.find('.js-post-link-title').text(this.model_.get('title') || url);
    this.$el.find('.js-post-link-subtitle').text(this.model_.get('subtitle') || url);
    this.$el.find('.js-post-link-summary').text(this.model_.get('summary') || '');
    this.$el.find('.js-post-video-thumbnail-container')
      .toggle(this.model_.get('videoThumbnail') != null)
      .find('.js-post-video-link').attr('href', url)
      .find('.js-post-video-thumbnail')
      .prop('src', this.model_.get('videoThumbnail') || '');
  }

  this.$el.toggle(url.length > 0);
};

exports = LinkContentView;
